export const SWAP_COMMISSION = 0.005
export const CYCLES_MINT_COMISSION = 0.05
const SWAP_PROVIDER_COMMISSION = 0.003

export const SWAP_COMMISSION_TOTAL = SWAP_COMMISSION + SWAP_PROVIDER_COMMISSION

export const STAKE_COMMISSION = 0.01

export const COMMISSIONS_WALLETS = [
  'cxzp7-t526w-ggqn4-jbd65-jtaqg-kf7gr-jaxmm-3fiol-fsx5u-r4fth-lae',
  'jpish-ddmau-bafpv-mwr3k-6yuxy-acyde-t2y6y-nufkx-soodd-gzfhh-uae',
  '24kee-axza3-dh4t3-vdsot-7ezgb-xlndz-4ei3x-5aurb-cogij-dr4dm-wae',
  'ujimm-o7e25-jk74t-ivcjb-frqvz-ozqqp-hsv3f-beg4c-nw4p6-kgp3r-4ae',
]

export const SWAP_COMMISSION_MEMO = 1337
export const STAKE_COMMISSION_MEMO = 1338
export const CYCLE_MINT_COMISSIONS_MEMO = 1339
